export default __webpack_public_path__ + "static/FancyMediaContentOne-cf69795c8b3140ba96ac64bf1873a897.webp";